// extracted by mini-css-extract-plugin
export default {"simpleTable":"wHmqPLzVvKnh86z6XH-aj","tableBoxed":"_1Z2me08BSMmY4OklKFxPun","tableBordered":"CiQKAulJwucEz7_3LZioZ","clickableColumn":"_1i10DXeNW0kXzKTKsnquxQ"};